import { render, staticRenderFns } from "./TestError.vue?vue&type=template&id=53d468c9"
import script from "./TestError.vue?vue&type=script&lang=js"
export * from "./TestError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports